// extracted by mini-css-extract-plugin
export default {"linksSection":"vI-z"};